import Image1 from '../../assets/project1.png'
import Image2 from '../../assets/project2.png'
import Image3 from '../../assets/project3.png'
import Image4 from '../../assets/project4.png'
import Image5 from '../../assets/project5.png'
import Image6 from '../../assets/project6.png'
/*import Image7 from '../../assets/project7.jpg'*/
import Image8 from '../../assets/project8.png'
import Image9 from '../../assets/project9.png'

const data = [
    {
        id: 1,
        category: 'frontend',
        image: Image1,
        title: "Pomodoro Focus ",
        desc: "Pomodoro Focus: Boost productivity with this sleek web app, tailor-made for the Pomodoro technique. Easily set customizable time intervals and colors, empowering users to optimize study or work sessions with efficiency and focus.",
        demo: 'https://pomodoroostudy.netlify.app',
        github: 'https://github.com/Mouin-bkr/Pomodoro_web_app'
    },
    {
        id: 2,
        category: 'frontend',
        image: Image2,
        title: "Jungle House",
        desc: "Jungle House: An online plant shop, representing one of my initial ventures into web development. Despite its simplicity, its aesthetic appeal remains a personal favorite, showcasing my early journey in crafting visually engaging digital experiences.",
        demo: 'https://planthsopistaken.netlify.app',
        github: 'https://github.com/Mouin-bkr/PlantShop'
    },
    {
        id: 3,
        category: 'frontend',
        image: Image3,
        title: "Photo Gallery ",
        desc: " A bespoke photo gallery developed for a client, designed to showcase his artwork and personal brand. This project allowed me to merge creativity with functionality, providing a platform for the client to exhibit his talents and achievements.",
        demo: 'https://mouin-bkr.github.io/DraWithMe/',
        github: 'https://github.com/Mouin-bkr/DraWithMe'
    },
    {
        id: 4,
        category: 'frontend',
        image: Image4,
        title: "Tape ",
        desc: "An elegant recording tool enhanced with animations, tailored for a client's video recording needs. Leveraging CSS and JavaScript, this project seamlessly integrates visual appeal with user functionality, delivering a polished solution for capturing memorable moments.",
        demo: 'https://mouin-bkr.github.io/Tape/',
        github: 'https://github.com/Mouin-bkr/Tape'
    },
    {
        id: 5,
        category: 'uiux',
        image: Image5,
        title: "Felnoo ",
        desc: "A comprehensive UI design crafted for a web application aimed at preschools or private schools. This platform streamlines educational activities and preserves student memories, offering a seamless solution for enhancing learning experiences and fostering academic growth.",
        demo: 'https://www.figma.com/file/8RXtLVPJdiyE4jc9SOTyRa/Felnoo?type=design&node-id=0%3A1&mode=dev',
        github: 'https://github.com/Mouin-bkr'
    },
    {
        id: 6,
        category: 'backend',
        image: Image6,
        title: "Movie Hub ",
        desc: " A dynamic web application leveraging APIs to fetch movies along with their ratings, serving as a convenient platform for users seeking recommendations on what movie to watch. It provides a user-friendly interface for browsing and exploring a wide range of films.",
        demo: 'https://moviehuub.netlify.app',
        github: 'https://github.com/Mouin-bkr/movie-hub'
    },
    /*
    {
        id: 7,
        category: 'frontend',
        image: Image7,
        title: "Project Title Seven ",
        desc: "Provident similique accusantium nemo autem. Veritatis obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam nihil, eveniet aliquid culpa officia aut!",
        demo: 'http://egatortutorials.com',
        github: 'https://github.com/Mouin-bkr'
    }*/
    {
        id: 8,
        category: 'backend',
        image: Image8,
        title: "Connect 4 ",
        desc: "An engaging web-based rendition of the classic Connect 4 game, offering players the opportunity to compete against either another player or an AI opponent seamlessly integrated within the game.",
        demo: 'https://conect4game.netlify.app',
        github: 'https://github.com/Mouin-bkr/Connect4'
    },
    {
        id: 9,
        category: 'frontend',
        image: Image9,
        title: "Birthday Wish ",
        desc: "A lighthearted website designed as a playful joke for a friend or loved one's birthday celebration. Featuring an interactive 'Click Me' button that playfully changes positions with each click, culminating in a delightful display of fireworks to mark the special occasion.",
        demo: 'https://mouin-bkr.github.io/Birthday-Wish/',
        github: 'https://github.com/Mouin-bkr/Birthday-Wish'
    }
]


export default data